import { createAction, props } from '@ngrx/store';
import { BUSINESS_TYPE } from '../../../model/login';

export const GET_BUSINESS_TYPE = createAction(
  'GET_BUSINESS_TYPE',
  props<{ payload: BUSINESS_TYPE[] }>()
);
